export const getPaymentMethodLabel = (method?: string): string => {
  const methods: Record<string, string> = {
    CASH: "Efectivo",
    TRANSFER: "Transferencia bancaria",
    LINK: "Link de pago",
    PROVIDER: "Proveedor de pago",
  };
  return method ? methods[method] || method : "No especificado";
};